// frontend/src/components/CustomStarRating.js
import React, { useState } from 'react';

const CustomStarRating = ({ count = 5, value, onChange }) => {
  const [hovered, setHovered] = useState(null);
  const stars = Array.from({ length: count }, (_, index) => index + 1);

  return (
    <div className="flex gap-1 custom-star-rating">
      {stars.map((star) => (
        <svg
          key={star}
          onClick={() => onChange && onChange(star)}
          onMouseEnter={() => onChange && setHovered(star)}
          onMouseLeave={() => onChange && setHovered(null)}
          className={`w-6 h-6 ${
            onChange ? 'cursor-pointer' : 'cursor-default'
          } transition-transform duration-200 ease-out ${
            star <= (hovered || value)
              ? 'text-yellow-300 scale-110' // Brighter yellow, slight scale-up
              : 'text-gray-600' // Darker gray for empty stars
          }`}
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      ))}
    </div>
  );
};

export default CustomStarRating;